import { z } from 'zod'

export const DashboardClassroomDiagnosticStateSchema = z.object({
  schoolClassroomId: z.number(),
  hasAssignments: z.boolean(),
  isDiagnosticStartExists: z.boolean(),
  isDiagnosticEndExists: z.boolean(),
  diagStartQuizVersionIds: z.array(z.number()),
  diagEndQuizVersionIds: z.array(z.number())
})

export type DashboardClassroomDiagnosticStateEntity = z.infer<
  typeof DashboardClassroomDiagnosticStateSchema
>
